import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { QrCaptureResponseComponent } from './qr-capture-response.component';

import { QrPayStudentComponent } from './qr-pay-student.component';
import { QrPaylayoutComponent } from './qr-paylayout.component';




const routes: Routes = [
  {
      path: '', component: QrPaylayoutComponent,
      children: [


          { path: 'qrCaptureResponse', component: QrCaptureResponseComponent }

      ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class QrFeePaymentRoutingModule { }
